import React, { useEffect, useState } from 'react';
import { Users, Ticket, ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface UrgencyBannerProps {
  spots: number;
  onSale: () => void;
}
export function UrgencyBanner({
  spots,
  onSale
}: UrgencyBannerProps) {
  const [viewers, setViewers] = useState(48);
  const [isSticky, setIsSticky] = useState(false);
  const [recentSale, setRecentSale] = useState({
    show: false,
    text: ''
  });
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        // Aparece sticky cuando la sección de compra está cerca de entrar o ya entró
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const viewerInterval = setInterval(() => {
      setViewers(prev => prev + (Math.random() > 0.5 ? 1 : -1));
    }, 3000);
    const sales = ['1 cupón vendido hace 5 mins', 'Nuevo acceso desde Mendoza hace 2 min', '1 cupón reservado hace instantes'];
    const saleInterval = setInterval(() => {
      setRecentSale({
        show: true,
        text: sales[Math.floor(Math.random() * sales.length)]
      });
      onSale(); // Notify parent to update counters
      setTimeout(() => setRecentSale({
        show: false,
        text: ''
      }), 4000);
    }, 40000);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(viewerInterval);
      clearInterval(saleInterval);
    };
  }, []);
  return <>
      {/* Floating Notification (When NOT sticky) */}
      <AnimatePresence data-id="element-226">
        {!isSticky && recentSale.show && <motion.div initial={{
        opacity: 0,
        x: -50,
        y: 50
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.8
      }} className="fixed bottom-6 left-6 z-[60] bg-white text-violet-950 p-4 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.2)] border border-violet-100 flex items-center gap-4 max-w-sm" data-id="element-227">
            <div className="w-10 h-10 bg-violet-100 rounded-full flex items-center justify-center text-violet-600 shrink-0" data-id="element-228">
              <ShoppingCart size={20} data-id="element-229" />
            </div>
            <div data-id="element-230">
              <p className="text-xs font-black text-violet-400 uppercase tracking-widest" data-id="element-231">
                Venta Reciente
              </p>
              <p className="font-bold text-sm leading-tight" data-id="element-232">
                {recentSale.text}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Sticky Banner */}
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="text-white py-1.5 fixed top-0 left-0 w-full z-50 shadow-lg border-b border-violet-200/20 bg-[#2E1065]/95 backdrop-blur-sm" data-id="element-233">
        <div className="max-container px-4 flex flex-wrap justify-center items-center gap-4 text-xs font-black uppercase tracking-tighter" data-id="element-234">
          <div className="flex text-[12px] font-[600] font-[Poppins,_sans-serif] gap-[6px] flex-row items-center justify-start" data-id="element-235">
            <span className="relative flex h-2 w-2" data-id="element-236">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-237"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" data-id="element-238"></span>
            </span>
            <Users size={14} className="text-violet-300" data-id="element-239" />
            {viewers} PERSONAS MIRANDO
          </div>
          <div className="flex items-center gap-2 font-[600] text-[12px]" data-id="element-240">
            <span className="relative flex h-2 w-2" data-id="element-241">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-242"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-243"></span>
            </span>
            <Ticket size={14} className="text-violet-300" data-id="element-244" />
            CUPOS DISPONIBLES: {spots}
          </div>

          {/* Integrated Notification (When sticky) */}
          <AnimatePresence data-id="element-245">
            {isSticky && recentSale.show && <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} className="flex items-center gap-2 bg-violet-100 text-violet-950 px-3 py-1 rounded font-bold text-xs" data-id="element-246">
                <ShoppingCart size={14} data-id="element-247" />
                {recentSale.text}
              </motion.div>}
          </AnimatePresence>
        </div>
      </motion.div>
    </>;
}